module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"CANDELA","routes":{"systems":"Systems","users":"Users","pricelist":"Upload price list","transactionreports":"Transaction Reports","templatedefinitions":"Template Definitions"},"language":"Language","about":"About","user":{"user":"Profile","settings":"Settings","signout":"Sign out"}},"da":{"title":"CANDELA","routes":{"systems":"Systemer","users":"Brugere","pricelist":"Upload prisliste","transactionreports":"Transaktionsrapporter","templatedefinitions":"Skabelondefinitioner"},"language":"Sprog","about":"Om","user":{"user":"Profil","settings":"Indstillinger","signout":"Log ud"}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./WebApp/components/Layout.vue
// module id = 587
// module chunks = 0